$(document).ready(function() {

//360
var panoramaFOV = 25;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
 panoramaFOV = 100;
}

if ( $( "#pannuotrauka" ).length ) {
  var PSV = new PhotoSphereViewer({
      panorama: '/img/panorama.jpg',
      container: 'pannuotrauka',
      loading_img: 'https://raw.githubusercontent.com/mistic100/Photo-Sphere-Viewer/3.1.0/example/photosphere-logo.gif',
      navbar: 'autorotate zoom',
      caption: 'SVAKO',
      default_fov: panoramaFOV,

      default_long: "-0.2",
      default_lat: "-19.5",
      anim_speed: '0rpm',
      mousewheel: false,
      size: {
        height: 500
      }
    });
};



// footer links clicker

$('.footer-links a').on('click', function(e){
      window.open($(this).attr('href'),"_self");
});

//studijos click

$('.studitem').on('click', function(){
    window.open($(this).find('a:first-child').attr('href'),"_self")
});

    //sidebar menu


    $('#sidebar-nav ul li').on('click', function(e) {

        event.preventDefault();
        window.open($(this).find('> a').attr('href'), '_self', false);
        event.stopPropagation();

    });


    $('#sidebar-nav .caret').on('click', function(e) {
        event.preventDefault();
        var menuitem = $(this).closest('li');
        menuitem.siblings().find('ul').slideUp();
        menuitem.find('> ul').slideToggle();

        event.stopPropagation();

    });


    // menu click fix

    // ADD SLIDEDOWN ANIMATION TO DROPDOWN //
    $('.dropdown').on('show.bs.dropdown', function(e) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    });

    // ADD SLIDEUP ANIMATION TO DROPDOWN //
    $('.dropdown').on('hide.bs.dropdown', function(e) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    });

    $('#navbar-mobile ul li').on('click', function(e) {

        event.preventDefault();
        window.open($(this).find('> a').not(".disabled").attr('href'), '_self', false);
        event.stopPropagation();

    });
    $('#navbar-mobile .caret').on('click', function(e) {
        event.preventDefault();
        var menuitem = $(this).closest('li');
        menuitem.siblings().find('ul').slideUp();
        menuitem.find('> ul').slideToggle();

        event.stopPropagation();

    });

    $(window).resize(function() {
        if ($('#nav-icon3').hasClass('open')) {
            var windowW = $(window).width();
            if (windowW > 991) {
                $('#nav-icon3').removeClass('open');
                $('#navbar-mobile').hide();

            }
        }

    });



    ///menu icon

    $('#nav-icon3').on('click', function() {
        $('#navbar-mobile').slideToggle();
    });


    //facebook


    $(window).bind("load resize", function() {
        var container_width = $('#WrapperID').width();

        $('#WrapperID').html('<div class="fb-page" ' +
            'data-href="' + $("#WrapperID").data("href") + '"' +
            ' data-width="' + container_width + '" data-height="500" data-tabs="timeline" data-show-faces="true" ' +
            'data-stream="true" data-header="true"></div>');
        FB.XFBML.parse();
    });

    //table auto

    $('.cb-text').find('table').wrap(function() {
  return "<div style='overflow-x:auto'></div>";
});



    //checkboxes


    $(function() {

        var $uniformed = $(".aplankyk-forma input").not(".skipThese, .submitform");
        $uniformed.uniform();
    });

    //meniu

    $('.sb-icon-search').on('click', function() {
        $('#navbar ul li ').toggleClass('nohover');
    });

    $('#navbar a.dropdown-toggle ').on('click', function(e) {
        var targetLink = $(this).attr('href');
        window.open(targetLink, '_self');
    });

    //menu colors hover
    $('#navbar ul li ul li ul li a').hover(
        function() {
            $(this).closest('ul').parent().css('background-color', '#30a1b5')
        },
        function() {
            $(this).closest('ul').parent().css('background-color', '')
        });


    // Kalendorius
    $(function() {


        var lang = document.documentElement.lang;

        switch (lang) {
            case 'lt':
                Flatpickr.l10n.weekdays = {
                    shorthand: ["Se", "Pr", "An", "Tr", "Ke", "Pe", "Še"],
                    longhand: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadinis"]
                };
                Flatpickr.l10n.months = {
                    shorthand: ["Sau", "Var", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gru"],
                    longhand: ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"]
                };
                break;

            case 'ru':
                Flatpickr.l10n.weekdays = {
                    shorthand: ['Сб', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт'],
                    longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
                };

                Flatpickr.l10n.months = {
                    shorthand: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                    longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
                };
                break;
            default:

                Flatpickr.l10n.weekdays = {
                    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
                };
                Flatpickr.l10n.months = {
                    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                };



        }

        Flatpickr.l10n.firstDayOfWeek = 1;



        $(".event-nuo, .event-iki").flatpickr({

            "time_24hr": true,
            "mode": "single",

        });


    });




    //select2
    $(".event-select").select2({
        minimumResultsForSearch: Infinity
    });





    //newsletter



    function formatAjaxErrors(res) {
        var errors = [];
        for (var bag in res.responseJSON) {
            for (var i in res.responseJSON[bag]) {
                errors.push(res.responseJSON[bag][i]);
            }
        }
        return errors.join('<br/>');
    }

    $('#newsletter').submit(function(e) {
        e.preventDefault();
        var $this = $(this);

        $.ajax({
            url: $(this).attr('action'),
            data: $this.serializeArray(),
            type: 'post',
            dataType: "json",
            success: function(res) {
                $.notify.defaults({
                    className: "success"
                });
                $.notify(res.messages, {
                    type: 'success',
                    globalPosition: 'top center',
                    placement: {
                        from: 'top',
                        align: 'center'
                    }
                });
                $this.find('input[name="email"]').val('');
            },
            error: function(res) {
                $.notify.defaults({
                    className: "error"
                });
                $.notify(formatAjaxErrors(res), {
                    type: 'error',

                    globalPosition: 'top center',
                    placement: {
                        from: 'top',
                        align: 'center'
                    }
                });
                $this.find('input[name="email"]').focus();
            }
        });
    });


    //gallery


    var slider = new MasterSlider();

    slider.control('arrows');
    slider.control('circletimer', {
        color: "#FFFFFF",
        stroke: 9
    });
    slider.control('thumblist', {
        autohide: false,
        dir: 'v',
        type: 'tabs',
        align: 'right',
        margin: 0,
        space: 0,
        width: 125,
        height: 80,
        hideUnder: 550
    });

    slider.setup('masterslider', {
        width: 760,
        height: 440,
        space: 0,
        view: 'wave'
    });

    // menu

    $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function() {
        $(this).toggleClass('open');
    });

    // search
    $('.sb-search-input').addClass('animated');



    var w = $(window).width();
    $(window).resize(function(){
      if ($(window).width()==w) return;
      w = $(window).width();
      $('.sb-search-input').hide();
    });


    $('.sb-icon-search').on('click', function(e) {
        var windowW = $(window).width();

        if (windowW <= 991) {
            if ($('.sb-search-input').hasClass('fadeInDown')) {
                $('.sb-search-input').removeClass('fadeInDown fadeInRight fadeOutRight').addClass('fadeOutUp');
                setTimeout(function() {
                    $('.sb-search-input').hide();
                }, 300);
            } else {
                $('.sb-search-input').addClass('fadeInDown').removeClass('fadeOutUp fadeInRight fadeOutRight').show();
            }
        } else {
            if ($('.sb-search-input').hasClass('fadeInRight')) {
                $('.sb-search-input').removeClass('fadeInRight fadeInDown fadeOutUp').addClass('fadeOutRight');
                setTimeout(function() {
                    $('.sb-search-input').hide();
                }, 300);
            } else {
                $('.sb-search-input').addClass('fadeInRight').removeClass('fadeOutRight fadeInDown fadeOutUp').show();
            }
        }



    });
    /*
        $('html').click(function (e) {
            if ($(e.target).attr('class') == 'sb-icon-search' && $(e.target).attr('class') == 'sb-search-input') {

            } else {
                  $('.sb-search-input').addClass('fadeOutUp').removeClass('fadeInRight fadeInDown fadeOutRight').show();
            }
        });
*/

    // lightbox

    $('a[data-rel^=lightcase]').lightcase({
        swipe: true,
        maxHeight: 1080,
        maxWidth: 1920,
        showTitle: false,
        showCaption: false,


    });

    //lang selector
    $(function() {

        var aktLi = $('.language_bar_chooser .active').closest('li').detach();
        aktLi.prependTo($('.language_bar_chooser'));


        $('.language_bar_chooser .active').on('click', function(e) {
            e.preventDefault();
            var windowW = $(window).width();

            if (windowW <= 991) {
                $('.language_bar_chooser').animate({
                    height: 111
                }, 200);
                console.log($('.language_bar_chooser').height());
                if ($('.language_bar_chooser').height() > 40) {
                    $('.language_bar_chooser').animate({
                        height: 40
                    }, 200);
                }
            }

        });

        $('#lang-selection a').on('click', function(e) {
            e.preventDefault();
            var lang = $(this).text();
            lang = lang.trim();
            $('#invisible-lang').val(lang);
            $(this).closest('form').trigger('submit');
        });
    });

    //footer fixer
    $(function() {
        /*
        jQuery(window).resize(function () {
            $('main').css('padding-bottom', $('#footer').innerHeight());
        });
        $('main').css('padding-bottom', $('#footer').innerHeight());
				*/
    });
    //scroll
    $(function() {
        /*
        $("html").niceScroll({
            'zindex': 99999,
            'cursorcolor': '#b2bdbe',
            'cursorborder': '#b2bdbe',
            'cursorwidth ': '10px',
            'scrollspeed': 100, // scrolling speed
            'mousescrollstep': 100, // scrolling speed with mouse wheel (pixel)
        });
				*/
    });

    //sliders
    $(function() {
        $('.home-zmogeliukai .row').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1300,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }],
            customPaging: function(slider, i) {
                return '<span class="slick-dots-light"></span>';
            },
        });




        $('.home-studijos .row').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1300,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }],
            customPaging: function(slider, i) {
                return '<span class="slick-dots-light"></span>';
            },
        });

        $('.main-sliderino-wrap').slick({
            dots: false,
            infinite: true,
            speed: 1200,
            slidesToShow: 1,
            nextArrow: '<i class="fa fa-angle-right slick-next" aria-hidden="true"></i>',
            prevArrow: '<i class="fa fa-angle-left slick-prev" aria-hidden="true"></i>',
            adaptiveHeight: false,

        });


        $('.home-news-mobile-wrap').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          adaptiveHeight: true,
          responsive: [{
              breakpoint: 991,
              settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 2
              }
          }, {
              breakpoint: 480,
              settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 1
              }
          }],
          customPaging: function(slider, i) {
              return '<span class="slick-dots-light"></span>';
          },

        });
        $('.home-apie-procentai .row').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          adaptiveHeight: true,
          responsive: [{
              breakpoint: 991,
              settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 2
              }
          }, {
              breakpoint: 480,
              settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 2
              }
          }],


        });


    });


    //ProgressBar
    $(function() {


        $('.home-procentai').each(function() {
            var circle = new ProgressBar.Circle(this, {
                color: '#aaa',
                // This has to be the same size as the maximum width to
                // prevent clipping
                strokeWidth: 8,
                trailWidth: 8,
                easing: 'easeInOut',
                duration: 1400,
                text: {
                    autoStyleContainer: false
                },
                from: {
                    color: '#1fbad6',
                    width: 8
                },
                to: {
                    color: '#1fbad6',
                    width: 8
                },
                // Set default step function for all animate calls
                step: function(state, circle) {
                    circle.path.setAttribute('stroke', state.color);
                    circle.path.setAttribute('stroke-width', state.width);

                    var value = Math.round(circle.value() * 100);
                    if (value === 0) {
                        circle.setText('');
                    } else {
                        circle.setText(value + '%');
                    }

                }
            });



            circle.animate($(this).attr('data-procentai') / 100); // Number from 0.0 to 1.0
        });


    });


});
